export const TypingIndicator = () => {
  return (
    <div className="mb-6 animate-fadeIn">
      <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-purple-50 w-fit ml-4">
        <div className="flex gap-1">
          <div className="w-2 h-2 rounded-full bg-[#4c3794] animate-[pulse_1.4s_ease-in-out_infinite]" style={{ animationDelay: '0s' }} />
          <div className="w-2 h-2 rounded-full bg-[#4c3794] animate-[pulse_1.4s_ease-in-out_infinite]" style={{ animationDelay: '0.2s' }} />
          <div className="w-2 h-2 rounded-full bg-[#4c3794] animate-[pulse_1.4s_ease-in-out_infinite]" style={{ animationDelay: '0.4s' }} />
        </div>
      </div>
    </div>
  );
};
